module.exports = __webpack_public_path__ + "img/cbr-plus-circle-18.cba010e9.svg";